/**
 * Every `data-testid` of the session that more than one file reads (§5.1, §5.3,
 * §9.5, §12.1).
 *
 * The arrangement of `protocoles/contracts.ts` and `reader/contracts.ts`, and
 * for the same reason: the e2e suite and the capture scripts do NOT compile
 * this package, so they recopy these strings - and a mark spelled in two
 * components is a selector that resolves in one and not the other.
 */
export const SESSION_TEST_IDS = {
  /** The door: the choice page of §5.1, one card per entry. */
  choice: 'session-choix',
  choiceCard: 'session-choix-carte',
  /** The reprise page of §5.3 - « Reprendre » and « Recommencer ». */
  resume: 'session-reprise',
  /** The dead-link screen: revoked, expired, unknown, or nothing that resolves. */
  dead: 'session-lien-mort',
  /** The session itself, the frame the theme paints. */
  player: 'session-lecteur',
  /** The box inside the frame that scrolls a page taller than the window (#168). */
  scroll: 'session-defilement',
  /**
   * The conversation of §9.5 - the whole protocol page: header, thread,
   * composer. It replaces the seam of #60 (`session-couture`), which was
   * removed with its component in #65: `sessionProtocolMode` no longer answers
   * `seam`, so a mark nothing draws is a selector that can only ever time out.
   */
  conversation: 'session-conversation',
  /** One bubble, with `data-role` (`interviewer` / `person`) and `data-writing`. */
  bubble: 'session-bulle',
  /** The typing indicator, between the press and the first `delta`. */
  typing: 'session-frappe',
  /** The multi-line composer and its send button. */
  composer: 'session-composeur',
  /** « Continuer » at the end of the protocol - never an automatic hand-over. */
  continue: 'session-continuer',
  /** The sober, fixed screen of an expired session (§5.3). */
  expired: 'session-expiree',
  /** The sober screen of a session an operator INTERRUPTED (issue #199, interruption.md §6). */
  interrupted: 'session-interrompue',
  /** The engine's excuse on a `closed` session (§5.3). */
  closed: 'session-fermee',
  /**
   * « Donner mon avis » on the closing panel (retour-experience.md §6.2, issue
   * #176): the one button an experience with a page of retour adds to it.
   */
  giveFeedback: 'session-avis',
  /*
    Sessions (§12.1) used to keep its table and row marks here, and they moved
    to `admin/sessions/contracts.ts` with the lot that built the three operator
    screens. They name an administration table, not one of the person's
    screens, and this file is the accord of the person's screens. The STRINGS
    did not change - `session.spec.ts` copies the row's value.
  */
} as const;
